/** Platform tenant for the Rail Intel system-administrator account — not a customer company. */
export const SYSTEM_ADMIN_COMPANY_CODE = "5473";

export function isSystemAdminCompanyCode(code: string | null | undefined): boolean {
  return String(code ?? "").trim().toLowerCase() === SYSTEM_ADMIN_COMPANY_CODE.toLowerCase();
}

export const SYSTEM_ADMIN_COMPANY_PROTECTED_ERROR =
  "The Rail Intel system administrator company cannot be deleted, suspended, or have terms records viewed.";
